<template>
  <div class="card bg-light">
    <div class="card-header">
      Advanced Search
      <span class="float-end sticky-top" :class="getCssClass" style="cursor: pointer" @click="close()">
        <font-awesome-icon icon="xmark" />
      </span>
    </div>
    <div class="card-body">
      <smart-input id="groupName" v-model="model.groupName" label="Group Name" :is-required="false" />
      <smart-select id="groupType" v-model="model.groupType" label="Group Type" :options="groupTypeSelect"
        :is-required="false" />
      <smart-input id="tmln" v-model="model.tmln" label="TMLN" :is-required="false" />

      <div class="row">
        <div class="col-6">
          <smart-button class-override="btn-outline-secondary" :disabled="false" :loading="false" :click="reset">
            Reset
          </smart-button>
        </div>
        <div class="col-6">
          <smart-submit :small="true" :disabled="false" :loading="loading" :click="newAdvancedSearch" label="Apply" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SmartInput,
  SmartSubmit,
  SmartButton,
  SmartSelect,
} from '@trustmark-2005-ltd/trustmark-shared-components';

export default {
  name: 'LicenceNumberSearchAdvanced',
  components: {
    SmartButton,
    SmartSubmit,
    SmartInput,
    SmartSelect,
  },
  emits: ['reset-requested', 'error-message-changed', 'close'],
  data() {
    return {
      loading: false,
      model: {
        groupName: null,
        groupType: null,
        tmln: null
      }
    };
  },
  computed: {
    pageNumber() {
      return this.$store.state.licenceNumber.pageNumber;
    },
    lastGroupSearchConfig() {
      return this.$store.state.licenceNumber.lastGroupSearchConfig;
    },
    isAdvancedSearch() {
      return this.lastGroupSearchConfig.type === 'advanced';
    },

    groupTypeSelect() {
      return ['Organisation A', 'Organisation B', 'Organisation C'];
    },
  },
  watch: {
    pageNumber() {
      if (this.isAdvancedSearch) {
        this.advancedSearch();
      }
    },
  },
  methods: {
    newAdvancedSearch() {
      this.$store.commit('licenceNumber/setSearchPageNumber', 0, { root: true });
      this.advancedSearch();
    },
    advancedSearch() {
      this.$emit('error-message-changed', null);
      this.loading = true;

      const payload = JSON.parse(JSON.stringify(this.model));

      payload.pageParameters = {
        size: 10,
        number: this.pageNumber,
      };
      payload.sort = {
        item: 'groupName',
        direction: 'ascending',
      };
      payload.filterType = 0;

      this.$store
        .dispatch('licenceNumber/groupSearchAdvanced', payload)
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$emit('error-message-changed', err.message);
        });
    },
    reset() {
      this.model.groupName = null;
      this.model.groupType = null;
      this.model.tmln = null;
      this.$emit('reset-requested', null);
    },
    close() {
      this.$emit('close', null);
    },
  },
};
</script>
